import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import ProductEntityInterface from 'common/types/entities/ProductInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createProduct(
  parentId: string,
  masterBlockId?: MasterBlockId,
): ProductEntityInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Product, parentId, masterBlockId),
    showQuantity: true,
    padding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
  }
}
